import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostBinding,
  Input,
  OnChanges,
  SecurityContext,
  SimpleChanges
} from "@angular/core";
import { DomSanitizer} from "@angular/platform-browser";

@Directive({
  selector: "[highlight]"
})
export class HighlightDirective implements AfterViewInit {
  @Input("highlight") searchTerm: string;
  @Input() caseSensitive = false;
  @Input() customClasses = "";

  constructor(private el: ElementRef, private sanitizer: DomSanitizer) {}

  ngAfterViewInit(): void {
    this.highlight();
  }

  highlight() {
    if (this.el?.nativeElement) {
      const text = (this.el.nativeElement as HTMLElement).textContent;
      if (this.searchTerm === "") {
        return;
      } else {
        const regex = new RegExp(
          this.searchTerm,
          this.caseSensitive ? "g" : "gi"
        );
        const newText = text.replace(regex, (match: string) => {
          return `<mark class="highlight ${this.customClasses}">${match}</mark>`;
        });
        const sanitzed = this.sanitizer.sanitize(
          SecurityContext.HTML,
          newText
        );
        (this.el.nativeElement as HTMLElement).innerHTML = sanitzed;
      }
    }
  }
}